export const reportWebVitals = (onPerfEntry?: () => void) => {
  const env = (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env;

  if (env?.DEV === true) {
    return;
  }

  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};
